import React from 'react';
import { connect } from 'react-redux';

import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import Page from '../../pages/Page';

import * as accessibilityStatementActions from '../../../actions/accessibility_statement';
import PageHeader from "../../modules/PageHeader/index";

class ViewAccessibilityStatement extends React.Component {

    componentDidMount() {
        this.props.refreshAccessibilityStatement(this._getServiceId());
    }

    _getServiceId() {
        return this.props.match.params.id;
    }

    render() {

        return (
            <Page>
                <PageMeta title="View Accessibility Statement" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>

                    {this.props.accessibilityStatement && (
                        <PageHeader>
                            <h1>{this.props.accessibilityStatement.name}</h1>
                        </PageHeader>
                    )}

                    <PageSection>

                        {this.props.accessibilityStatement &&
                            <div className="accessibility-statement-viewer" dangerouslySetInnerHTML={{__html: this.props.accessibilityStatement.content}} />
                        }

                    </PageSection>

                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ...state.accessibilityStatement
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        refreshAccessibilityStatement(serviceId) {
            dispatch(accessibilityStatementActions.refreshAccessibilityStatement(serviceId));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewAccessibilityStatement);